function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_3911",
  "data-name": "Rect\\xE1ngulo 3911",
  width: 20.122,
  height: 20.07,
  fill: "#e8e8e8"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2848",
  "data-name": "Grupo 2848",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_14909",
  "data-name": "Trazado 14909",
  d: "M121.135,121.73a.877.877,0,0,1-.617-.254l-4.531-4.509a.879.879,0,1,1,1.183-1.3c.018.016.035.033.051.05l4.531,4.509a.879.879,0,0,1-.617,1.5Z",
  transform: "translate(-101.89 -101.659)",
  fill: "#e8e8e8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_14910",
  "data-name": "Trazado 14910",
  d: "M49.431,42.62a.727.727,0,0,1-.039,1.052L47.15,45.913l2.236,2.236a.776.776,0,0,1-1.1,1.1L46.053,47.01l-2.3,2.3A.718.718,0,1,1,42.737,48.3l2.3-2.3L42.473,43.43a.776.776,0,0,1,1.1-1.1L46.138,44.9l2.241-2.241a.727.727,0,0,1,1.052-.039",
  transform: "translate(-37.207 -37.084)",
  fill: "#e8e8e8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_14911",
  "data-name": "Trazado 14911",
  d: "M17.016,5.936A8.553,8.553,0,0,0,16.21,4.21s0,0,0,0a8.765,8.765,0,0,0-4.268-3.6s0,0,0,0c-.2-.079-.4-.151-.6-.214l-.21-.061c-.138-.041-.277-.075-.415-.108s-.285-.061-.43-.087C10.069.1,9.852.068,9.632.046,9.339.017,9.04,0,8.738,0s-.6.016-.894.045c-.22.022-.438.053-.651.092-.144.026-.287.055-.429.087s-.279.069-.415.108l-.21.061c-.2.063-.405.134-.6.214,0,0,0,0,0,0a8.765,8.765,0,0,0-4.268,3.6s0,0,0,0A8.553,8.553,0,0,0,.46,5.936a8.738,8.738,0,1,0,16.556,0m-8.278,10a7.2,7.2,0,1,1,7.2-7.2,7.206,7.206,0,0,1-7.2,7.2",
  transform: "translate(0 -0.001)",
  fill: "#e8e8e8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_14912",
  "data-name": "Trazado 14912",
  d: "M17.016,5.936A8.772,8.772,0,0,0,16.21,4.21s0,0,0,0a8.816,8.816,0,0,0-4.268-3.6s0,0,0,0c-.2-.077-.4-.149-.6-.214l-.21-.061c-.136-.039-.277-.075-.415-.108s-.285-.061-.43-.087C10.069.1,9.852.068,9.632.046,9.339.017,9.04,0,8.738,0s-.6.016-.894.045c-.22.022-.438.053-.651.092-.144.026-.287.055-.429.087s-.279.069-.415.108l-.21.061c-.2.065-.405.136-.6.214,0,0,0,0,0,0a8.816,8.816,0,0,0-4.268,3.6s0,0,0,0a8.736,8.736,0,1,0,15.75,1.726m-8.278,10a7.2,7.2,0,1,1,7.2-7.2,7.206,7.206,0,0,1-7.2,7.2",
  transform: "translate(0 -0.001)",
  fill: "#e8e8e8"
}));

var SvgSearchEmpty = function SvgSearchEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_2849",
    "data-name": "Grupo 2849",
    width: 20.122,
    height: 20.07,
    viewBox: "0 0 20.122 20.07",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search-empty.87b6490d.svg";
export { ForwardRef as ReactComponent };